import { Trans, t } from '@lingui/macro';

import { Card, CardContent } from 'components/ui/card';
import { Skeleton } from 'components/ui/skeleton';

export default function EventPageSkeleton() {
    return (
        <div
            className="max-w-screen-xl mx-auto p-4 lg:pt-8"
            aria-busy="true"
            aria-label={t`Loading event`}
        >
            <Card className="overflow-hidden flex flex-col lg:flex-row border-solid border-border shadow-none">
                <Skeleton className="w-full lg:w-[min(520px,48%)] lg:shrink-0 aspect-[2/1] lg:self-start rounded-none" />

                <div className="flex flex-col flex-1 border-t lg:border-t-0 lg:border-l border-solid border-border">
                    <div className="flex flex-col flex-1 p-4">
                        <div className="sm:px-1 space-y-2">
                            <Skeleton className="h-7 sm:h-8 w-3/4" />
                            <Skeleton className="h-4 w-1/3" />
                        </div>

                        <div className="flex items-center gap-2 mt-6 mb-2 sm:mx-1">
                            <Skeleton className="h-[18px] w-[18px] shrink-0 rounded-full" />
                            <Skeleton className="h-4 w-1/2" />
                        </div>

                        <div className="flex items-start gap-2 mb-2 sm:mx-1">
                            <Skeleton className="h-[18px] w-[18px] shrink-0 rounded-full mt-0.5" />
                            <Skeleton className="h-4 w-2/3" />
                        </div>
                    </div>

                    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-end px-4 pb-3 border-t border-border lg:border-t-0 mt-auto">
                        <Skeleton className="h-[46px] w-[140px] sm:w-[160px] rounded-md" />
                    </div>
                </div>
            </Card>

            <h2 className="mt-12 text-3xl md:text-4xl font-extrabold font-inter text-foreground">
                <Trans>About</Trans>
            </h2>

            <Card className="my-8 border-solid border-border shadow-none">
                <CardContent className="p-4 sm:p-6 space-y-3">
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-5/6" />
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-4/5" />
                    <Skeleton className="h-4 w-2/3" />
                </CardContent>
            </Card>
        </div>
    );
}
